import NetworkManager from "../../../network/network-manager";
import Parser from "../network/parser.js";
export default {
  async loadPostsFilesClicks(context) {
    await NetworkManager.get(
      context,
      `post-file-click`,
      "PostFileClick",
      "setPostsFilesClicks",
      Parser
    );
  },
  async updatePostFileClickName(context , payload) {
    await NetworkManager.put(
      context,
      `post-file-click/${payload.id}?name=${payload.name}`,
      null,
      "PostFileClick",
      null,
      Parser
    );
  },
  async resetCount(context , payload) {
    await NetworkManager.put(
      context,
      `post-file-click/reset-count/${payload.id}`,
      null,
      "PostFileClick",
      "resetItemCount",
      Parser
    );
  }
};
